import { logger } from '@/utils/logger';

export const LOADED_VERSION = process.env.NEXT_PUBLIC_VERSION || null;

export const VERSION_ENDPOINT = '/api/version';

export const VERSION_CHECK_THROTTLE_MS = 60_000;

export function isVersionSkew(loaded: string | null, server: string | null): boolean {
  if (!loaded || !server) return false;
  return loaded !== server;
}

export async function fetchServerVersion(signal?: AbortSignal): Promise<string | null> {
  try {
    const response = await fetch(VERSION_ENDPOINT, { cache: 'no-store', signal });
    if (!response.ok) return null;

    const data = (await response.json()) as { version?: unknown };
    return typeof data?.version === 'string' ? data.version : null;
  } catch {
    return null;
  }
}

export function logVersionSkew(serverVersion: string) {
  logger.warn('[version-skew] deploy detectado, avisando o usuário', {
    channel: 'version-skew',
    loadedVersion: LOADED_VERSION,
    serverVersion,
    url: globalThis.location?.href,
  });
}
